"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBannerBreadcrumbs = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Breadcrumbs = require("../Breadcrumbs");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for displaying breadcrumbs in TopBanner. For empty `breadcrumbs` returns `null`.
 */
const TopBannerBreadcrumbs = ({
  breadcrumbs,
  renderSeparately
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!breadcrumbs || breadcrumbs.length < 1) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BreadcrumbsRoot, {
    "data-testid": getTestId(_constants.TOP_BANNER_BREADCRUMBS),
    renderSeparately: renderSeparately,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumbs.Breadcrumbs, {
      breadcrumbs: breadcrumbs
    })
  });
};
exports.TopBannerBreadcrumbs = TopBannerBreadcrumbs;
TopBannerBreadcrumbs.displayName = 'Breadcrumbs';
